module.exports = __webpack_public_path__ + "img/bjdaohang.500d3faa.png";